import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { PageHeader } from "@/components/PageHeader";
import api, { apiError } from "@/lib/api";

export default function VisibilityPage() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/visibility").then((r) => setRows(r.data.sections)).catch((e) => toast.error(apiError(e))); }, []);
  const toggle = async (key, visible) => {
    try {
      const { data } = await api.put("/admin/visibility", { defaults: { [key]: visible } });
      setRows(data.sections);
      toast.success("Default saved");
    } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="max-w-3xl space-y-6" data-testid="visibility-page">
      <PageHeader eyebrow="Platform" title="Public view defaults" subtitle="Global default for each public-view section. Company overrides (set on each company) win over these." />
      <section className="rise-in divide-y divide-slate-100 rounded-lg border border-slate-200 bg-white shadow-sm">
        {(rows || []).map((s) => (
          <label key={s.key} className="flex cursor-pointer items-center justify-between px-6 py-4" data-testid={`default-row-${s.key}`}>
            <div>
              <div className="text-sm font-medium text-slate-900">{s.label}</div>
              <div className="text-xs text-slate-500">{s.visible ? "Visible on public views" : "Hidden on public views"}</div>
            </div>
            <Switch checked={s.visible} onCheckedChange={(v) => toggle(s.key, v)} data-testid={`default-switch-${s.key}`} />
          </label>
        ))}
      </section>
    </div>
  );
}
